"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.format = void 0;
const database_1 = require("./models/database");
/**
 * Formats given array of tables in compact format to JSON Schema array
 *
 * @param json Compact JSON format (array of tables).
 * @param options Options available to format as JSON Schema.
 */
exports.format = (json, options) => {
    const database = new database_1.Database();
    database.parseCompactJson(json);
    const jsonSchema = database.getTables().map((t) => t.toJSON(options));
    return jsonSchema;
};
